<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Usuários
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        disable-sort
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  class="ml-3"
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top v-if="nivelUsuarioApelido !== 'I'">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top v-if="nivelUsuarioApelido !== 'I'">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usuario.uuid_usu_id ? 'Editar usuário' : 'Novo usuário'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsuarios">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usuario.uuid_gru_id"
                :items="modulos"
                clearable
                clear-icon="close"
                label="Grupo*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingGroups"
                :disabled="salvando || loadingGroups"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="usuario.usu_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_email"
                label="E-mail*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_apelido"
                label="Usuário*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
              <v-text-field
                @click:append="show1 = !show1"
                :label="usuario.uuid_usu_id ? 'Preencha caso desejar alterar a senha' : 'Senha*'"
                hint="Mínimo 6 caracteres"
                counter
                outlined
                :loading="salvando"
                :disabled="salvando"
                :type="show1 ? 'text' : 'password'"
                v-model="usuario.password"
                :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                :rules="usuario.uuid_usu_id ? [] : [rules.required, rules.min]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="usuario.usu_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(usuario.usu_imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usuario.usu_imagem && !isObject(usuario.usu_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div>
                  <div class="avatar" :style="`background-image: url('${usuario && usuario.usu_imagem ? usuario.usu_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUser()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Usuário <b class="text-primary">{{usuario ? usuario.usu_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'

export default {
  data () {
    return {
      user: null,
      nivelUsuarioApelido: null,
      loading: true,
      loadingGroups: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      search: '',
      searchFinal: null,
      show1: false,
      modulos: [],
      total: 0,
      options: {},
      carregando: false,
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'usu_id'
        },
        { text: 'Nome', value: 'usu_nome' },
        { text: 'E-mail', value: 'usu_email' },
        { text: 'Usuário', value: 'usu_apelido' },
        { text: 'Tipo', value: 'usu_tipo' },
        { text: 'Módulo', value: 'modulo' }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres'
      },
      usuario: {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        usu_imagem: '',
        password: ''
      },
      distribuidor: '',
      distribuidores: [],
      loadingDistribuidores: false,
      integrador: '',
      integradores: [],
      loadingIntegradores: false,
      distribuidorAnterior: ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true

      Api.post('relatorios', {
        headers: this.someHeader(),
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        busca: this.searchFinal,
        type: 'usuarios'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Usuários', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.getGroups()
      this.getIntegradores()
      this.getDistribuidores()
      this.getDataFromApi()
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getGroups () {
      this.loadingGroups = true
      await Api.get('grupos')
        .then(res => {
          var arrayGroups = []
          res.data.map(gru => {
            arrayGroups.push({
              'text': gru.gru_nome,
              'value': gru.uuid_gru_id
            })
          })
          this.modulos = arrayGroups
          this.loadingGroups = false
        })
        .catch(err => {
          this.loadingGroups = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os grupos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'Usuarios', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getDataFromApi()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDataFromApi () {
      this.carregando = true
      this.total = 0
      this.dados = []
      let filtro = '&filtro='

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }

      if (this.distribuidor) {
        filtro += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        filtro += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        filtro += '&busca=' + this.searchFinal
      }

      await Api.get(`usuarios?page=${pagina}&per_page=${itensPagina}${filtro}`)
        .then(res => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            let info = []
            this.total = res.data.total

            res.data.data.map(item => {
              info.push({
                usu_id: item.usu_id,
                usu_nome: item.usu_nome,
                usu_imagem: item.usu_imagem,
                usu_email: item.usu_email,
                usu_apelido: item.usu_apelido,
                modulo: item.grupo ? item.grupo.gru_nome : '',
                uuid_gru_id: item.grupo ? item.grupo.uuid_gru_id : '',
                uuid_usu_id: item.uuid_usu_id,
                usu_tipo: item.fk_dis_id_distribuidor ? 'Distribuidor' : item.fk_int_id_integrador ? 'Integrador' : 'Master'
              })
            })
            this.dados = info
          }
          this.carregando = false
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagem () {
      this.usuario.usu_imagem = ''
      this.usuario.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditUser () {
      if (!this.$refs.formUsuarios.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usuarios/novo'
      let editado = false
      if (this.usuario.uuid_usu_id) {
        endpoint = 'usuarios/edita'
        editado = true
      }
      if (this.$refs.file) {
        this.usuario.imagem = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.usuario).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.usuario.usu_imagem[0].file)
            }
          }
        } else {
          if (this.usuario[key] != null) {
            formData.append(key, this.usuario[key])
          }
        }
      })

      if (this.user.uuid_dis_id) {
        formData.append('uuid_dis_id', this.user.uuid_dis_id)
      }
      if (this.user.uuid_int_id) {
        formData.append('uuid_int_id', this.user.uuid_int_id)
      }

      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Usuário atualizado com sucesso!' : 'Usuário cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getDataFromApi()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`usuarios/remove/${this.usuario.uuid_usu_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getDataFromApi()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover usuário!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelUsuarioDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.usuario = {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        password: ''
      }
      if (this.$refs.formUsuarios) {
        this.$refs.formUsuarios.resetValidation()
      }
      this.dialogNovo = false
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }

        if (this.nivelUsuarioApelido === 'M' || this.nivelUsuarioApelido === 'D') {
          this.headers.push({
            text: 'Ações',
            value: 'actions',
            align: 'center',
            sortable: false,
            width: 110
          })
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/gestor/Usuarios.vue